export const PIX_ISSUER_ID = 62;
export const ISSUERS_WITHOUT_INSTALLMENTS = [13, 21, 52, 53, 54, 55, 56, 57, 58, 59];
